import ButtonProps from '@shared/types/props/pressable';
import Event from './event';

interface Params {
  text: string;
  action?: (asset?: Event | null, node?: number | null) => void;
  icon: (props: ButtonProps) => JSX.Element;
}

class FloatingMenuButton {
  text: string;
  action?: (asset?: Event | null, node?: number | null) => void;
  icon: (props: ButtonProps) => JSX.Element;

  constructor({ text, action, icon }: Params) {
    this.text = text;
    this.action = action;
    this.icon = icon;
  }
}

export { FloatingMenuButton };
